(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      var key = 'citera:ann:' + bar.getAttribute('data-ann-key');
      try {
        if (localStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
      var close = bar.querySelector('[data-ann-close]');
      if (close) {
        close.addEventListener('click', function () {
          bar.hidden = true;
          try {
            localStorage.setItem(key, '1');
          } catch (e) {}
        });
      }
    }
    document.querySelectorAll('[data-ann-bar]').forEach(initBar);
    // Theme editor: re-init when the section is re-rendered live.
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-ann-bar]').forEach(initBar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    // Scroll reading-progress bar
    var bar = document.querySelector('[data-reading-progress]');
    var content = document.querySelector('.article__content');
    if (bar && content) {
      // Geometry cached, refreshed only on resize; scroll does one rAF-batched
      // read of window.scrollY + one style write — no per-frame forced reflow.
      var contentTop = 0;
      var total = 1;
      var ticking = false;
      var measure = function () {
        var rect = content.getBoundingClientRect();
        contentTop = rect.top + window.scrollY;
        total = Math.max(content.offsetHeight - window.innerHeight, 1);
      };
      var paint = function () {
        ticking = false;
        var scrolled = Math.min(Math.max(window.scrollY - contentTop, 0), total);
        bar.style.width = (scrolled / total) * 100 + '%';
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(paint);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener(
        'resize',
        function () {
          measure();
          onScroll();
        },
        { passive: true }
      );
      measure();
      paint();
    }

    // Copy-link share button
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-link]');
      if (!btn) return;
      var url = btn.getAttribute('data-url');
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const openBtn = document.querySelector('[data-zoom-open]');
    const dialog = document.querySelector('[data-lightbox]');
    if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;
    const lbImg = dialog.querySelector('[data-lightbox-img]');
    const main = document.getElementById('product-media-main');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const urls = thumbs.length
      ? thumbs.map((t) => t.dataset.full)
      : [main ? main.currentSrc || main.src : ''];
    // Keep alt text in sync when arrow-navigating between images.
    const alts = thumbs.length
      ? thumbs.map((t) => {
          const img = t.querySelector('img');
          return (img && img.alt) || '';
        })
      : [main ? main.alt || '' : ''];
    let idx = 0;
    const show = (i) => {
      idx = (i + urls.length) % urls.length;
      lbImg.src = urls[idx];
      lbImg.alt = alts[idx] || lbImg.alt;
    };
    const activeIndex = () => {
      const a = thumbs.findIndex((t) => t.getAttribute('aria-pressed') === 'true');
      return a >= 0 ? a : 0;
    };
    openBtn.addEventListener('click', () => {
      show(activeIndex());
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = dialog.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(idx - 1));
    dialog.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(idx + 1));
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    // Return focus to the zoom trigger when the lightbox closes (WCAG 2.4.3).
    dialog.addEventListener('close', () => openBtn.focus());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const initSlideshow = (root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
    if (!track || slides.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const status = root.querySelector('[data-slideshow-status]');
    let current = 0;

    // Set the initial inert state synchronously — the IntersectionObserver
    // fires async, so without this every slide is tabbable on first paint.
    slides.forEach((s, i) => {
      if (i !== 0) {
        s.setAttribute('inert', '');
        s.setAttribute('aria-hidden', 'true');
      }
    });

    const go = (i, smooth = true) => {
      current = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[current].offsetLeft,
        behavior: smooth && !reduce ? 'smooth' : 'auto',
      });
    };

    root.querySelector('[data-slideshow-next]')?.addEventListener('click', () => go(current + 1));
    root.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => go(current - 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    // Sync dots with the visible slide
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            current = slides.indexOf(e.target);
            dots.forEach((d, i) =>
              d.setAttribute('aria-current', i === current ? 'true' : 'false'),
            );
            // Announce the new slide ("Slide X of Y") to screen readers.
            if (status) status.textContent = e.target.getAttribute('aria-label') || '';
            // Keep off-screen slides out of the tab order and AT.
            slides.forEach((s, i) => {
              if (i === current) {
                s.removeAttribute('inert');
                s.removeAttribute('aria-hidden');
              } else {
                s.setAttribute('inert', '');
                s.setAttribute('aria-hidden', 'true');
              }
            });
          }
        });
      },
      { root: track, threshold: 0.6 },
    );
    slides.forEach((s) => io.observe(s));

    // Autoplay (disabled for reduced motion; pauses on hover/focus and via toggle)
    if (root.dataset.autoplay === 'true' && !reduce) {
      const speed = Math.max(2, parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;
      const toggle = root.querySelector('[data-slideshow-toggle]');
      let timer = setInterval(() => go(current + 1), speed);
      // Manual pause via the toggle overrides hover/focus resume.
      let paused = false;
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (!paused && !timer) timer = setInterval(() => go(current + 1), speed);
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      toggle?.addEventListener('click', () => {
        paused = !paused;
        // One ARIA model only: the swapping Pause/Play label. Combining it with
        // aria-pressed double-announces state ("Play, pressed").
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute(
          'aria-label',
          paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause,
        );
        if (paused) {
          stop();
        } else {
          start();
        }
      });
    }
  };
  document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
  // Theme editor: initialize slideshows in sections added/re-rendered live.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
  });

  } catch(e) { console.error(e); }
})();
})();
